// extracted by mini-css-extract-plugin
module.exports = {"pageNF":"CciApps_pageNF__hSa_Y","spinner":"CciApps_spinner__2_0C5","chart":"CciApps_chart__2xUCX"};